/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PeriodSpecDetailContract} from '../../../api/contracts/period/period-spec-detail.contract';
import {PeriodSpecDetailModel} from './period-spec-detail.model';
import {PeriodicityBaseMapper} from '../periodicity-base/periodicity-base.mapper';

export class PeriodSpecBaseMapper {
    static fromPeriodSpecBaseContract(input: PeriodSpecDetailContract): PeriodSpecDetailModel {
        let model: PeriodSpecDetailModel;

        if (input != null) {
            model = {
                code: input.code,
                periodicity: PeriodicityBaseMapper.fromPeriodicityBaseContract(input.periodicity),
                maxBundles: input.maxBundles
            };
        }
        return model;
    }
}
